import { render, staticRenderFns } from "./islem.vue?vue&type=template&id=22aeb666&scoped=true&"
import script from "./islem.vue?vue&type=script&lang=js&"
export * from "./islem.vue?vue&type=script&lang=js&"
import style0 from "./islem.vue?vue&type=style&index=0&id=22aeb666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aeb666",
  null
  
)

export default component.exports